import { LayoutModule } from './layout/layout.module';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, Inject, LOCALE_ID, NgModule } from '@angular/core';
import { DecimalPipe, registerLocaleData, LocationStrategy, HashLocationStrategy, APP_BASE_HREF, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// animations
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// i18n
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NZ_I18N, zh_CN, en_US, zh_TW } from 'ng-zorro-antd/i18n';

// NG-ZORRO---NgZorroAntdModule废弃,需要一个个模块的引入,故统一在shareModule引入Zorro需要依赖module
import { NgZorroAntdModule } from 'src/app/ng-zorro-antd.module';
import { ShareModule } from 'src/app/shared/share-module.module';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
// import { NoopInterceptor } from './shared/service/noop-interceptor';
import { MatomoModule } from 'ngx-matomo';
import { AuthService } from "src/app/shared/auth/auth.service";
import { ConfigService } from './shared/service/config.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NzImageModule } from 'ng-zorro-antd/image';
import { WMSM001Component } from 'src/app/WMSM-Pages/WMSM001/WMSM001.component';
import { WMSM002Component } from 'src/app/WMSM-Pages/WMSM002/WMSM002.component';
import { WmsmChangeHistoryComponent } from 'src/app/WMSM-Pages/wmsm-ChangeHistory/wmsm-ChangeHistory.component';
import { WmsmStatementQueryComponent } from 'src/app/WMSM-Pages/wmsm-StatementQuery/wmsm-StatementQuery.component';
import { WmsmStatementMaintainComponent } from 'src/app/WMSM-Pages/wmsm-StatementMaintain/wmsm-StatementMaintain.component';
import { WmsmStatementabnormalComponent } from 'src/app/WMSM-Pages/wmsm-Statementabnormal/wmsm-Statementabnormal.component';
import { WmsmStatementQueryWHQComponent } from 'src/app/WMSM-Pages/wmsm-StatementQueryWHQ/wmsm-StatementQueryWHQ.component';
import { WmsmStatementMaintainWHQComponent } from 'src/app/WMSM-Pages/wmsm-StatementMaintainWHQ/wmsm-StatementMaintainWHQ.component';
import { WmsmStatementAbnormalWHQComponent } from 'src/app/WMSM-Pages/wmsm-StatementabnormalWHQ/wmsm-StatementabnormalWHQ.component';
import { WmsmContractTemplateManagementComponent } from 'src/app/WMSM-Pages/wmsm-ContractTemplateManagement/wmsm-ContractTemplateManagement.component';
import { WmsmScheduleManagementComponent } from 'src/app/WMSM-Pages/wmsm-ScheduleManagement/wmsm-ScheduleManagement.component';
import zh from '@angular/common/locales/zh';
import en from '@angular/common/locales/en';
import localeZhTw from '@angular/common/locales/zh-Hant';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

//监听用户操作
import { NgIdleModule } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MomentModule } from 'ngx-moment';

registerLocaleData(zh);
registerLocaleData(en);
registerLocaleData(localeZhTw);
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function MSALInstanceFactory(): IPublicClientApplication {
  const config = window['APP_CONFIG'];
  return new PublicClientApplication({
    auth: {
      clientId: config.entraID.auth.clientId,
      authority: config.entraID.auth.authority,
      redirectUri: config.entraID.auth.redirectUri,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    authRequest: (msalService, httpReq, originalAuthRequest) => {
      return {
        ...originalAuthRequest,
        authority: `https://login.microsoftonline.com/${originalAuthRequest.account?.tenantId ?? 'organizations'}`
      };
    }
  };
}
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    },
    loginFailedRoute: '/login'
  };
}

const OWERMODULES = [
  WMSM001Component,
  WMSM002Component,
  WmsmChangeHistoryComponent,
  WmsmStatementQueryComponent,
  WmsmStatementabnormalComponent,
  WmsmStatementMaintainComponent,
  WmsmStatementQueryWHQComponent,
  WmsmStatementMaintainWHQComponent,
  WmsmStatementAbnormalWHQComponent,
  WmsmContractTemplateManagementComponent,
  WmsmScheduleManagementComponent,
];

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { RouteReuseStrategy } from '@angular/router';
import { ZwRouteReuseStrategy } from './route-strategy.service';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    DragDropModule,
    AngularMultiSelectModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NzImageModule,
    FormsModule,
    LayoutModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgZorroAntdModule,
    ShareModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    NzTabsModule,
    MatomoModule,
    MomentModule,
    NgIdleModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: ZwRouteReuseStrategy },
    { provide: NZ_I18N, useValue: zh_CN, },
    { provide: NZ_I18N, useValue: en_US },
    { provide: NZ_I18N, useValue: zh_TW },
    DecimalPipe,
    AuthService,
    DatePipe,
    OWERMODULES,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
      deps: [ConfigService],
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})

export class AppModule {
}
